import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

import { Box, FormLabel, Grid } from '@material-ui/core'

import { IOSSwitch, IOSSwitchProps } from '../IOSSwitch'

import { StoreAccountProps } from '../../types/accountProps'

export type AccountUseMarkingsSwitchProps =
  StoreAccountProps & Pick<IOSSwitchProps, 'checked' | 'onChange'>

export const AccountUseMarkingsSwitch =
  observer(
    ({account, ...passProps}: AccountUseMarkingsSwitchProps) => {
      const classes = useSettingsPageStyles()

      if (!account.allowMarkingCodes) {
        return null
      }

      return (
        <Grid item xs={9}>
          <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
            <Grid item className={classes.root} xs={12}>
              <Box width={'100%'} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <FormLabel className={classes.unifiedPricesLabel}>
                    Использовать Честный знак
                  </FormLabel>
                </Box>

                <IOSSwitch {...passProps}/>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )
    })